import { Fragment, useState } from "react";
import cx from "classnames";
import Nav from "../AppNav/VerticalNavWrapper";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PerfectScrollbar from "react-perfect-scrollbar";
import HeaderLogo from "../AppLogo";
import { getAppStore, connectAppStore } from "../../Store/AppStore";

const AppSidebar = (props)=>{
    const [height, setHeight] = useState(window.innerHeight);
    const [init,setInit] = useState(false);
    const handleResize = () => {
      if(height != window.innerHeight){
          setHeight(window.innerHeight);
      }
    };
    if(init === false){
      window.addEventListener('resize', handleResize);
      setInit(true);
    }
    const toggleMobileSidebar = () => {
    };

    let {
      enableBackgroundImage,
      backgroundImage,
      backgroundImageOpacity,
    } = props;
  const [appStoreState] = getAppStore(props);
    const theme = appStoreState.appThemeReducer;
    let {
      showSideBar
    }  = theme;
     return (
      <Fragment>
        <div className={showSideBar?"":"hideAppSiderBar"}>
        <div className="sidebar-mobile-overlay" onClick={toggleMobileSidebar}/>
        <TransitionGroup>
          <CSSTransition component="div"
            className="app-sidebar sidebar-shadow"
             appear={true} enter={false} exit={false} timeout={500}>
            <div>
              <HeaderLogo />
                <PerfectScrollbar style={{ height: height, maxHeight:height - 250}} >
                <div className="app-sidebar__inner">
                  <Nav />
                </div>
              </PerfectScrollbar>
              <div className={cx("app-sidebar-bg", backgroundImageOpacity)}
                style={{
                  backgroundImage: enableBackgroundImage
                    ? "url(" + backgroundImage + ")"
                    : null,
                }}>
              </div>
            </div>
          </CSSTransition>
        </TransitionGroup>
        </div>
      </Fragment>
    );
}

export default connectAppStore(AppSidebar);
